export default __webpack_public_path__ + "static/media/shoes.a785b4e0.svg";